import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=5fdccc2d&scoped=true"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"
import style0 from "./AmountInput.vue?vue&type=style&index=0&id=5fdccc2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdccc2d",
  null
  
)

export default component.exports